import styled, { keyframes } from 'styled-components'

const loading = keyframes`
	0%,
	40%,
	100% {
		transform: scale(0);
	}

	65% {
		transform: scale(1);
	}
`

type Props = {
	offset: number
}

export const Dot = styled.span<Props>`
	background-color: currentColor;
	display: block;
	border-radius: 50%;
	width: 0.5em;
	height: 0.5em;
	margin: 0.75em 0.25em;
	animation: ${loading} 2.2s infinite ease-in-out;
	animation-delay: ${({ offset }) => offset * 0.25 - 0.5}s;
`
